import { Updater } from "use-immer";

import {
  AudienceFilterTypeList,
  ExpressionPayloadType,
  UrlMatchList,
} from "@intelligems/ig-types";

import { TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS } from "../../utils/constants";

import { AddConditionButton } from "./AddConditionButton";
import { ConditionGroup } from "./ConditionGroup";
import {
  ExpressionBuilderContext,
  ExpressionBuilderContextType,
} from "./context";

export interface ExpressionsBuilderProps extends ExpressionBuilderContextType {
  expressionsList: ExpressionPayloadType[];
  setExpressionsList: Updater<ExpressionPayloadType[]>;
}

export const ExpressionsBuilder = (props: ExpressionsBuilderProps) => {
  const { expressionsList, setExpressionsList, ...ctx } = props;
  const configuredQueryParams = expressionsList.reduce((acc, expList) => {
    expList.queries.forEach((exp) => {
      if (exp.key) {
        acc.add(exp.key);
      }
    });
    return acc;
  }, new Set<string>());

  const onAddGroup = () => {
    const filterTypeIdx = ctx.renderContext === "pageTargeting" ? 2 : 0;
    const newExpression = {
      type: AudienceFilterTypeList[filterTypeIdx],
      queries: [
        {
          type: AudienceFilterTypeList[filterTypeIdx],
          filter: UrlMatchList[0],
          key:
            AudienceFilterTypeList[filterTypeIdx] === "utm"
              ? Object.values(TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS)[0]
              : "",
          value: "",
        },
      ],
    };
    setExpressionsList((draft) => {
      draft.push(newExpression);
    });
  };

  return (
    <ExpressionBuilderContext.Provider
      value={{
        ...ctx,
      }}
    >
      {expressionsList.map((_, i) => {
        return (
          <ConditionGroup
            key={i}
            expressionsList={expressionsList}
            setExpressionsList={setExpressionsList}
            expressionsListIndex={i}
            configuredQueryParams={configuredQueryParams}
          />
        );
      })}
      <AddConditionButton
        nested={false}
        color={expressionsList.length === 0 ? "primary" : "secondary"}
        type={
          expressionsList.length === 0
            ? "add"
            : ctx.renderContext === "audience"
              ? "and"
              : "or"
        }
        onClick={onAddGroup}
      />
    </ExpressionBuilderContext.Provider>
  );
};
